module.exports = __webpack_public_path__ + "static/media/Frame 1261154685.4fe5e62e.svg";